/* eslint-disable no-console */
import React from 'react';
import './App.css';
// import { BrowserRouter as Router } from "react-router-dom";
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { OidcProvider } from '@axa-fr/react-oidc';
import RouteList from './Routes';

// 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_yjacun8kh/.well-known/openid-configuration',
// const configuration = {
//   client_id: 'interactive.public.short',
//   redirect_uri: window.location.origin + '/authentication/callback',
// Optional activate silent-signin that use cookies between OIDC server and client javascript to restore the session
//   silent_redirect_uri: window.location.origin + '/authentication/silent-callback',
//   scope: 'openid profile email api offline_access',
//   authority: 'https://demo.duendesoftware.com',
//   // authority: 'https://auth.watertechnologies.com',
//   service_worker_relative_url:'/OidcServiceWorker.js',
//   service_worker_only:true,
// };
// alert(process.env.REACT_APP_CALL_BACK_URI);
// alert(window.location.origin);
// create a china build run the command `npm run build-cn`
const configuration = {
  // client_id: 'Winflows_China',
  // redirect_uri: 'https://winflows.watertechs.cn/test',
  client_id: 'Winflows_Prod',
  redirect_uri: `${process.env.REACT_APP_CALL_BACK_URI}test`,
  // redirect_uri: process.env.REACT_APP_CALL_BACK_URI,
  // redirect_uri: window.location.origin + '/test',
  // redirect_uri: 'https://dev-winflows.watertechnologies.com/',
  // silent_redirect_uri: window.location.origin + '/authentication/silent-callback',
  // Optional activate silent-signin that use cookies between OIDC server and client javascript
  // to restore the session
  // redirect_uri: 'https://dev-winflows.watertechnologies.com/',
  // Optional activate silent-signin that use cookies between OIDC server and client javascript to restore the session
  // silent_redirect_uri: window.location.origin + '/test',
  // scope: 'email openid profile',
  scope: 'openid profile',
  authority: 'https://auth.watertechnologies.com',
  // authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_yjacun8kh',
  // authority: 'https://auth1.watertechnologies.com',
  service_worker_relative_url: '/OidcServiceWorker.js',
  service_worker_only: true,
};

function App() {

  return (
    <OidcProvider configuration={configuration} >
      <div className="App">
        {/* <Router> */}
        <RouteList />
        {/* </Router> */}
      </div>
    </OidcProvider>
  );
}

export default App;

// import React, { useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { createBrowserHistory } from 'history';
// import { connect } from 'react-redux';
// import Callback from './routes/Callback';
// import { initSessionFromCallbackURI } from './actions/session';
// import Home from './routes/Home';
// import Layout from './components/layout';
// import LogIn from './components/login';
// import Signup from './components/sign-up';
// import Forgot from './components/forgot-password';
// import Dashboard from './components/home';
// import RecentFileListForm from './components/recent_file_form/Form_RecentFileForm';
// import PreConfig from './components/preconfig_flowsheets';
// import MyProjectsPopup from './components/my-projects';
// import SharedProjectsPopup from './components/shared-projects';

// import './App.css';

// import Flow from './components/Flow';
// import './styles/global.scss';
// import './components/save.css';
// import FileHandling from './components/FileHandling';

// const history = createBrowserHistory();

// function mapStateToProps(state) {
//   // <Home />
//   return { session: state.session };
// }

// function mapDispatchToProps(dispatch) {
//   return {
//     initSessionFromCallbackURI: (href) =>
//       dispatch(initSessionFromCallbackURI(href)),
//   };
// }
// const App = (props) => {

//   return (
//     <Layout history={history} props={props}>
//       {/* <Router history={history}> */}
//       <Routes>
//         <Route path="/sign-in" element={<LogIn />} />
//       </Routes>
//       <Routes>
//         <Route path="/" element={<Home />} />
//       </Routes>
//       <Routes>
//         <Route path="/main" element={<Flow />} />
//       </Routes>
//       <Routes>
//         <Route path="/preconfig" element={<PreConfig />} />
//       </Routes>
//       <Routes>
//         <Route path="/my-projects" element={<MyProjectsPopup />} />
//       </Routes>
//       <Routes>
//         <Route path="/shared-projects" element={<SharedProjectsPopup />} />
//       </Routes>
//       <Routes>
//         <Route path="/filehandling" element={<FileHandling />} />
//       </Routes>
//       <Routes>
//         <Route path="/home" element={<Dashboard />} />
//       </Routes>
//       <Routes>
//         <Route path="/sign-up" element={<Signup />} />
//       </Routes>
//       <Routes>
//         <Route path="/forgot-password" element={<Forgot />} />
//       </Routes>
//       <Routes>
//         <Route path="/recent-files-list" element={<RecentFileListForm />} />
//       </Routes>
//       {/* </Router> */}
//     </Layout>
//   );
// };

// export default connect(mapStateToProps, mapDispatchToProps)(App);
